import React, { ReactNode, ReactNodeArray } from 'react'

import { Box } from '@vividseats/vivid-ui-kit'

import styles from '../styles.module.scss'

interface ConfettiWrapperProps {
    width: number
    height: number
    title: ReactNode
    perks: ReactNodeArray
}

export const Perks: React.FC<ConfettiWrapperProps> = ({ width, height, title, perks }) => (
    <Box
        paddingTop={7}
        className={styles.desktopSection}
        style={{ width: `${width}px`, height: `${height}px` }}
        data-testid="perks"
    >
        {title}
        <Box display="flex" justify="between" className={styles.subBox}>
            {perks.map((box) => box)}
        </Box>
    </Box>
)
